/**
 * External Dependencies
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../components/async-component';
import PageContent from '../../components/page-content';
import PageTitle from '../../components/page-title';
import PageWrap from '../../components/page-wrap';

/**
 * Component
 */
const HomePage = () => {
  const navigate = useNavigate();
  const redirect = localStorage.getItem('homepage');

  useEffect(() => {
    if (redirect !== '/') {
      const targetPath = redirect || '/';
      navigate(targetPath);
    }
  }, [redirect, navigate]);

  return (
    <PageWrap>
      <PageTitle
        breadcrumbs={{
          '/': 'Home',
        }}
      >
        <h1>HomePage</h1>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default HomePage;
